import { render, staticRenderFns } from "./blockWrapper.vue?vue&type=template&id=473674d8&scoped=true"
import script from "./blockWrapper.vue?vue&type=script&lang=js"
export * from "./blockWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473674d8",
  null
  
)

export default component.exports